import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";

export const skillnames = [
  "N/A",
  "Quarrying I",
  "Timber I",
  "Iron Ore I",
  "Farming I",
  "Shielded Maneuvers I",
  "Whoa There I",
  "Broken Bows I",
  "Pearl Harvesting I",
  "Keep Digging",
  "Marauder",
  "Close Quarters I",
  "Spearhead I",
  "Bullseye I",
  "Morale Boost",
  "Shielded Maneuvers II",
  "Whoa There II",
  "Broken Bows II",
  "Revival",
  "Fierce Loyalty",
  "Breath of Life",
  "Close Quarters II",
  "Spearhead II",
  "Bullseye II",
  "Close Quarters II\bI",
  "Book of Spearhead III",
  "Bullseye III",
];

export const SkillSelectorList = (props) => {
  const { label, param, setTaskConfig, taskConfig } = props;
  const skills = taskConfig[param];
  const skillIndices = ["s1", "s2", "s3", "s4", "s5"];
  return (
    <>
      <div>
        <span style={{ float: "left", marginBottom: "10px" }}>{label}</span>
      </div>
      {skillIndices.map((skillIndex) => {
        const options = skillnames.map((skillname) => {
          return { label: skillname, value: skillname };
        });
        return (
          <div style={{ paddingTop: "7px" }}>
            <AngSelect
              placeholder="Select skill"
              ng-model={skills[skillIndex]}
              options={options}
              onChange={({ value }) => {
                const newTaskConfig = { ...taskConfig };
                newTaskConfig[param][skillIndex] = value;
                setTaskConfig(newTaskConfig);
              }}
            />
          </div>
        );
      })}
    </>
  );
};
